export enum GameFormatsEnum {
  Default = 1,
  Premium,
  'City Trivia (Modified)',
  'Trivial Warfare',
  'Imbibing Nerds',
  'Questions in Groups',
  'Contest Predictor',
  'City Trivia'
}
